// src/pages/data/dataW/DataUI.jsx

import React, {useState} from 'react';
import AppComponentHeader from '../../../@crema/core/AppComponentHeader';
import AppGridContainer from '../../../@crema/core/AppGridContainer';
import Grid from '@mui/material/Grid';
import RowEditControlGrid from './DataController/RowEditControlGrid';
import PropTypes from 'prop-types';
import {Box, Button, Paper} from '@mui/material';
import UploadModal from './UploadModal/UploadModal';
import FilterListIcon from '@mui/icons-material/FilterList'; // Import the FilterList icon
import FilterCardSendData from 'components/FilterCard/FilterCardSendData';
import {BiExport} from 'react-icons/bi';
import ExportModal from './UploadModal/ExportModal';
import DeleteConfirmationModal from './UploadModal/DeleteConfirmationModal';
import LeadFailureHistoryModal from '../../../components/LeadFailureHistoryModal';

const DataUI = ({
  dataToShow,
  pageSize,
  setPageSize,
  exportingModalClose,
  exportingModal,
  exportingModalOpen,
  pageNumber,
  handleSearchChange,
  handleDateRangeChange,
  handleSentDateRangeChange,
  setPageNumber,
  exportingData,
  rowCount,
  customerMapping, // Passed from DataLG.jsx
  formatDate, // Add formatDate prop
  dominId,
  onFilterChange,
  onEditCommit,
  handleChange,
  setPatchEdited,
  affiliateIdWithoutNoApi,
  gettingData,
  toggleFilterCardVisibility,
  isFilterCardVisible,
  exportDataToExcle,
  handleOnSelect,
  handleCustomerChange,
  selected,
  allStatusCount,
  doneStatusCount,
  errorStatusCount,
  handleDomainChange,
  handleSendModalDomainChange,
  setShowUploadModal,
  showUploadModal,
  onUploadSubmitting,
  onDropDownChange,
  onDropDownSearch,
  affiliateId,
  errorData,
  selecteCustomer, // Added here
  domainSelected, // Added here
  upLoadingData,
  handleClear,
  userRole,
  deleteData,
  disableDataSource,
  handleCloseModal, // Added here
  // Lead History Props
  historyModalOpen,
  historyLeadId,
  historyIsDuplicate,
  handleOpenLeadHistory,
  handleCloseLeadHistory,
  // New Props for FilterCard
  handleClearFilters,
  filters,
  setFilters,
  scorcessOptions,
  includeHighlighted,
  handleIncludeHighlightedChange,
}) => {
  // State to manage delete modal visibility
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleOpenDeleteModal = () => setIsDeleteModalOpen(true);
  const handleCloseDeleteModal = () => setIsDeleteModalOpen(false);

  return (
    <>
      <AppComponentHeader title='Data Table' />
      <AppGridContainer>
        <Grid item xs={12}>
          {/* Button to toggle filter card */}
          <Button
            variant='contained'
            startIcon={<FilterListIcon />} // Add the filter icon
            onClick={toggleFilterCardVisibility}
            sx={{mr: 4}}
          >
            {isFilterCardVisible ? 'Hide Filters' : 'Show Filters'}
          </Button>
          <Button
            variant='contained'
            startIcon={<BiExport />} // Add the export icon
            onClick={exportingModalOpen}
          >
            {exportingData ? 'Exporting' : 'Export Data'}
          </Button>
        </Grid>

        {isFilterCardVisible && (
          <Grid item xs={12}>
            {/* Render FilterCard if isFilterCardVisible is true */}
            <FilterCardSendData
              domains={dominId}
              customers={affiliateId}
              dataSources={scorcessOptions}
              handleChange={handleChange}
              filters={filters}
              handleDomainChange={handleDomainChange}
              setFilters={setFilters}
              handleCustomerChange={handleCustomerChange}
              handleDateRangeChange={handleDateRangeChange}
              handleSentDateRangeChange={handleSentDateRangeChange}
              handleSearchChange={handleSearchChange}
              onApply={onFilterChange}
              onClear={handleClearFilters}
              disableDataSource={disableDataSource}
              includeHighlighted={includeHighlighted}
              handleIncludeHighlightedChange={handleIncludeHighlightedChange}
            />
          </Grid>
        )}

        {/* Rest of your code for rendering the data table and actions */}
        <Grid item xs={12}>
          {/* Conditional Rendering of Action Buttons for Admins */}
          {selected.length > 0 &&
            Array.isArray(userRole) &&
            userRole.includes('admin') && (
              <Box mb={2}>
                <Grid container spacing={2}>
                  <Grid item>
                    <Button
                      variant='contained'
                      onClick={() => setShowUploadModal(true)}
                    >
                      Upload Data
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant='contained'
                      color='error'
                      onClick={handleOpenDeleteModal}
                    >
                      Delete
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}

          {/* Data Grid/Table */}
          <Paper>
            <RowEditControlGrid
              userRole={userRole}
              dataToShow={dataToShow}
              pageSize={pageSize}
              setPageSize={setPageSize}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              rowCount={rowCount}
              customerMapping={customerMapping} // Pass customer mapping here
              onFilterChange={onFilterChange}
              onEditCommit={onEditCommit}
              setPatchEdited={setPatchEdited}
              gettingData={gettingData}
              formatDate={formatDate} // Pass formatDate here
              handleOnSelect={handleOnSelect}
              selected={selected}
              onOpenLeadHistory={handleOpenLeadHistory}
            />
          </Paper>
        </Grid>

        {/* Upload Modal */}
        <UploadModal
          open={showUploadModal}
          selecteCustomer={selecteCustomer}
          domainSelected={domainSelected}
          onSubmit={onUploadSubmitting}
          allStatusCount={allStatusCount}
          doneStatusCount={doneStatusCount}
          handleDomainChange={handleSendModalDomainChange}
          dominId={dominId}
          errorStatusCount={errorStatusCount}
          handleClose={handleCloseModal} // Ensure correct prop name
          onDropDownChange={onDropDownChange}
          onDropDownSearch={onDropDownSearch}
          affiliateId={affiliateIdWithoutNoApi}
          errorData={errorData}
          upLoadingData={upLoadingData}
          handleClear={handleClear}
          customerMapping={customerMapping} // Pass customerMapping
        />
      </AppGridContainer>
      <ExportModal
        exportingModal={exportingModal}
        exportingModalClose={exportingModalClose}
        exportDataToExcle={exportDataToExcle}
      />
      <DeleteConfirmationModal
        deleteModalOpen={isDeleteModalOpen}
        deleteModalClose={handleCloseDeleteModal}
          handleDelete={() => {
          deleteData();
          handleCloseDeleteModal();
        }}
      />
      <LeadFailureHistoryModal
        open={historyModalOpen}
        onClose={handleCloseLeadHistory}
        leadId={historyLeadId}
        isDuplicate={historyIsDuplicate}
      />
    </>
  );
};

DataUI.propTypes = {
  dataToShow: PropTypes.array.isRequired,
  pageSize: PropTypes.number.isRequired,
  setPageSize: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
  dominId: PropTypes.array.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onEditCommit: PropTypes.func.isRequired,
  setPatchEdited: PropTypes.func.isRequired,
  gettingData: PropTypes.bool.isRequired,
  handleOnSelect: PropTypes.func.isRequired,
  formatDate: PropTypes.func.isRequired,
  selected: PropTypes.array.isRequired,
  allStatusCount: PropTypes.number.isRequired,
  doneStatusCount: PropTypes.number.isRequired,
  errorStatusCount: PropTypes.number.isRequired,
  handleDomainChange: PropTypes.func.isRequired,
  handleSendModalDomainChange: PropTypes.func.isRequired,
  setShowUploadModal: PropTypes.func.isRequired,
  showUploadModal: PropTypes.bool.isRequired,
  exportingData: PropTypes.bool.isRequired,
  onUploadSubmitting: PropTypes.func.isRequired,
  handleCustomerChange: PropTypes.func.isRequired,
  onDropDownChange: PropTypes.func.isRequired,
  onDropDownSearch: PropTypes.func.isRequired,
  affiliateId: PropTypes.array.isRequired,
  affiliateIdWithoutNoApi: PropTypes.array.isRequired,
  exportingModal: PropTypes.bool.isRequired,
  exportingModalOpen: PropTypes.func.isRequired,
  exportingModalClose: PropTypes.func.isRequired,
  errorData: PropTypes.any.isRequired,
  upLoadingData: PropTypes.bool.isRequired,
  handleClear: PropTypes.func.isRequired,
  exportDataToExcle: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  handleDateRangeChange: PropTypes.func.isRequired,
  handleSentDateRangeChange: PropTypes.func.isRequired,
  userRole: PropTypes.array.isRequired,
  deleteData: PropTypes.func.isRequired,
  handleClearFilters: PropTypes.func.isRequired,
  selecteCustomer: PropTypes.bool.isRequired, // Added
  domainSelected: PropTypes.bool.isRequired, // Added
  handleCloseModal: PropTypes.func.isRequired, // Added
  disableDataSource: PropTypes.bool, // Added

  // New PropTypes for FilterCard
  filters: PropTypes.shape({
    domain: PropTypes.string,
    customer: PropTypes.string,
    country: PropTypes.string,
    dataSource: PropTypes.string,
    dateRange: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
    search: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  toggleFilterCardVisibility: PropTypes.func.isRequired,
  isFilterCardVisible: PropTypes.bool.isRequired,
  scorcessOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
    }),
  ).isRequired,
  countryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
    }),
  ),
  customerMapping: PropTypes.object.isRequired, // Corrected typo
  historyModalOpen: PropTypes.bool,
  historyLeadId: PropTypes.any,
  historyIsDuplicate: PropTypes.bool,
  handleOpenLeadHistory: PropTypes.func,
  handleCloseLeadHistory: PropTypes.func,
  includeHighlighted: PropTypes.bool,
  handleIncludeHighlightedChange: PropTypes.func,
};

export default DataUI;
